import * as React from "react";
import styled from "styled-components";

export const StyledAlert = styled.div`
  box-sizing: border-box;
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  word-wrap: break-word;
  border-radius: 2px;

  justify-content: center;
  text-align: center;

  &.error {
    background-color: rgba(230, 82, 90, 0.15) !important;
    min-height: 42px;
    display: flex;
    align-items: center;

    background-color: #fff2f0;
    border: 1px solid #ffccc7;
  }
`;

StyledAlert.displayName = "StyledAlert";

type AlertColors = "default" | "error"

interface IBadgeProps {
    color?: AlertColors;
    children: React.ReactNode | string;
}

export function Alert({
                          color = "default",
                          children
                      }: IBadgeProps): JSX.Element {

    return <StyledAlert className={color}>
        {children}
    </StyledAlert>;

}